import { css } from "@emotion/css";
import { Colors, Spacing } from "@snapchat/snap-design-system";

export const subTabsStyle = css`
    margin-bottom: ${Spacing.XL}px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 14%);

    > ul {
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;

        > li {
            cursor: pointer;

            display: flex;
            align-items: stretch;

            width: 100%;
            min-height: 103px;
            padding: ${Spacing.MD}px;

            /* overwriting dynamic SDS styles */
            text-align: left !important;

            background: #f2f2f2;
            outline: none;
            box-shadow: none;
        }
    }
`;

export const tabSelectedClassName = css`
    background: ${Colors.WHITE} !important;
`;
